import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, InputBase, IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';

const poData = [
  { po: 'PO1023', item: 'Carmozyme 250mg', qty: 200, delivery: '22 Aug 2026', status: 'pending', month: 'Aug' },
  { po: 'PO1032', item: 'Ayurvedic Tonic', qty: 80, delivery: '28 Aug 2026', status: 'pending', month: 'Aug' },
  { po: 'PO1019', item: 'Analgesic Syrup', qty: 150, delivery: '20 Aug 2026', status: 'transit', month: 'Aug' },
  { po: 'PO1011', item: 'Antibiotic Cap 500', qty: 300, delivery: '10 Aug 2026', status: 'delivered', month: 'Aug' },
  { po: 'PO1002', item: 'Ayurvedic Tonic', qty: 90, delivery: '02 Aug 2026', status: 'delivered', month: 'Aug' },
  { po: 'PO0996', item: 'Carmozyme 250mg', qty: 120, delivery: '26 Jul 2026', status: 'cancelled', month: 'Jul' },
  { po: 'PO0940', item: 'Antibiotic Cap 500', qty: 140, delivery: '18 May 2026', status: 'delivered', month: 'May' },
  { po: 'PO0910', item: 'Analgesic Syrup', qty: 90, delivery: '25 Mar 2026', status: 'delivered', month: 'Mar' },
];

const purchaseOrderStatusColors = {
  pending: 'amber',
  transit: 'blue',
  delivered: 'green',
  cancelled: 'red',
};

export default function PurchaseOrdersCard() {
  return (
    <Box className="card" style={{ minHeight: '400px' }}>
      <div className="card-head">
        <h3 className="card-title" id="vendPOTitle">My purchase orders</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <Box sx={{ position: 'relative', maxWidth: 200 }}>
            <SearchIcon sx={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-mut)', fontSize: 18 }} />
            <InputBase
              placeholder="Search POs..."
              sx={{ width: '100%', '& input': { paddingLeft: 32, fontSize: 12, height: 32 } }}
            />
          </Box>
          <Tooltip title="Filters">
            <IconButton size="small" aria-label="filters">
              <FilterListIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>PO Number</TableCell>
              <TableCell>Item</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Delivery</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="vendPOBody">
            {poData.map((row) => (
              <TableRow key={row.po} hover>
                <TableCell>{row.po}</TableCell>
                <TableCell>{row.item}</TableCell>
                <TableCell align="right">{row.qty}</TableCell>
                <TableCell align="right">{row.delivery}</TableCell>
                <TableCell>
                  <span className={`pill ${purchaseOrderStatusColors[row.status]}`}>
                    {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ color: 'var(--text-sec)', fontWeight: 600 }}>
                    {row.status === 'pending' ? 'Acknowledge' : row.status === 'transit' ? 'Track' : row.status === 'delivered' ? 'Delivered' : 'Cancelled'}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: 12, fontSize: '12px', color: 'var(--text-sec)' }} id="vendPOCount">
        {poData.length} shown
      </div>
    </Box>
  );
}
